(async () => {
    const carousels = document.querySelectorAll('[data-image-carousel]');

    if (carousels.length) {
        await import('/components/image-carousel/image-carousel-lazy');
    }
})();
